/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetCreditSummaryQueryVariables = Types.Exact<{
  [key: string]: never;
}>;
export type GetCreditSummaryQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    id: string;
    creditSummary: {
      __typename?: "CreditSummary";
      available: {
        __typename?: "CreditSummaryAvailable";
        totalAmount: {
          __typename?: "Money";
          currency: Types.Currency;
          value: number;
        };
      };
    };
  } | null;
};
export const GetCreditSummaryDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getCreditSummary"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "client"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "creditSummary"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "available"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "totalAmount"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "currency"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "value"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetCreditSummaryQuery__
 *
 * To run a query within a React component, call `useGetCreditSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditSummaryQuery, GetCreditSummaryQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetCreditSummaryQuery, GetCreditSummaryQueryVariables>(GetCreditSummaryDocument, options);
}
export function useGetCreditSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditSummaryQuery, GetCreditSummaryQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetCreditSummaryQuery, GetCreditSummaryQueryVariables>(GetCreditSummaryDocument, options);
}
export type GetCreditSummaryQueryHookResult = ReturnType<typeof useGetCreditSummaryQuery>;
export type GetCreditSummaryLazyQueryHookResult = ReturnType<typeof useGetCreditSummaryLazyQuery>;
export type GetCreditSummaryQueryResult = Apollo.QueryResult<GetCreditSummaryQuery, GetCreditSummaryQueryVariables>;